/* Keeps the LGG selling plan in sync with the line quantity.
   Shopify selling plans have no quantity dimension, so the per-quantity tier plans can be
   paired with any quantity. Left alone, a 3-bottle plan on a quantity of 1 bills $16.00
   per bottle forever. This re-prices the line to the plan that matches its actual quantity. */
(function () {
  var VARIANT = 51124147388705;
  var PLANS = { 1: 691274285345, 2: 691411124513, 3: 691411157281 };

  function planFor(qty) {
    return PLANS[qty] || (qty > 3 ? PLANS[3] : PLANS[1]);
  }

  var running = false;

  function sync() {
    if (running) return Promise.resolve();
    running = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fix = null;
        (cart.items || []).forEach(function (item) {
          if (fix) return;
          if (item.variant_id !== VARIANT) return;
          var alloc = item.selling_plan_allocation;
          if (!alloc || !alloc.selling_plan) return;
          var want = planFor(item.quantity);
          if (alloc.selling_plan.id !== want) {
            fix = { id: item.key, quantity: item.quantity, selling_plan: want };
          }
        });
        if (!fix) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(fix)
        }).then(function (r) { return r.json(); });
      })
      .then(function (changed) {
        running = false;
        if (!changed) {
          // Cart is consistent, so a later mismatch in the same session may reload again.
          sessionStorage.removeItem('lggPlanGuardReloaded');
          return;
        }
        if (!/\/cart\/?$/.test(window.location.pathname)) return;
        // One reload only. If the re-price somehow does not stick, do not loop the page.
        if (sessionStorage.getItem('lggPlanGuardReloaded')) return;
        sessionStorage.setItem('lggPlanGuardReloaded', '1');
        window.location.reload();
      })
      .catch(function (e) {
        running = false;
        console.warn('[lgg-plan-guard]', e);
      });
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var out = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
        out.then(function () { setTimeout(sync, 150); }).catch(function () {});
      }
    } catch (e) {
      console.warn('[lgg-plan-guard] hook', e);
    }
    return out;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.lggPlanGuardSync = sync;
})();
